import React from 'react'

const Ola6 = () => {
    return (
        <div className='container'>
            <h1>Convert a Binary Tree into its Mirror Tree</h1>
            <p>Mirror of a Tree: Mirror of a Binary Tree T is another Binary Tree M(T) with left and right children of all non-leaf nodes interchanged.&nbsp;<br/>&nbsp;</p>
            <p><strong>Solution (Recursive)</strong></p>
            <p>Algorithm – Mirror(tree):&nbsp;<br/>&nbsp;</p>
            <pre>{`(1)  Call Mirror for left-subtree    i.e., Mirror(left-subtree)
(2)  Call Mirror for right-subtree  i.e., Mirror(right-subtree)
(3)  Swap left and right subtrees.
          temp = left-subtree
          left-subtree = right-subtree
          right-subtree = temp`}</pre>

                   <div class="tabs">
    <input type="radio" name="tab" id="tab1"/>
    <label for="tab1">CPP</label>
    <input type="radio" name="tab" id="tab2"/>
    <label for="tab2">Java </label>
    <input type="radio" name="tab" id="tab3"/>
    <label for="tab3">Python</label>
    <input type="radio" name="tab" id="tab4"/>
    <label for="tab4">C</label>
  
    <div class="tab-content-wrapper">
      <div id="tab-content-1" class="tab-content">
      <div class="container">
    <div class="line number1 index0 alt2"><code class="comments">// C++ program to convert a binary tree</code></div>
    <div class="line number2 index1 alt1"><code class="comments">// to its mirror</code></div>
    <div class="line number3 index2 alt2"><code class="preprocessor">#include&lt;bits/stdc++.h&gt;</code></div>
    <div class="line number4 index3 alt1"><code class="keyword bold">using</code> <code
            class="keyword bold">namespace</code> <code class="plain">std;</code></div>
    <div class="line number5 index4 alt2">&nbsp;</div>
    <div class="line number6 index5 alt1"><code class="comments">/* A binary tree node has data, pointer</code></div>
    <div class="line number7 index6 alt2"><code class="comments">to left child and a pointer to right child */</code>
    </div>
    <div class="line number8 index7 alt1"><code class="keyword bold">struct</code> <code class="plain">Node</code></div>
    <div class="line number9 index8 alt2"><code class="plain">&#123;</code></div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">data;</code></div>
    <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">struct</code> <code class="plain">Node* left;</code></div>
    <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">struct</code> <code class="plain">Node* right;</code></div>
    <div class="line number13 index12 alt2"><code class="plain">&#125;;</code></div>
    <div class="line number14 index13 alt1">&nbsp;</div>
    <div class="line number15 index14 alt2"><code
            class="comments">/* Helper function that allocates a new node with</code></div>
    <div class="line number16 index15 alt1"><code
            class="comments">the given data and NULL left and right pointers. */</code></div>
    <div class="line number17 index16 alt2"><code class="keyword bold">struct</code> <code
            class="plain">Node* newNode(</code><code class="color1 bold">int</code> <code class="plain">data)</code>
    </div>
    <div class="line number18 index17 alt1"><code class="plain">&#123;</code></div>
    <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">struct</code> <code class="plain">Node* node = (</code><code
            class="keyword bold">struct</code> <code class="plain">Node*)</code></div>
    <div class="line number20 index19 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions bold">malloc</code><code class="plain">(</code><code
            class="keyword bold">sizeof</code><code class="plain">(</code><code class="keyword bold">struct</code> <code
            class="plain">Node));</code></div>
    <div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">node-&gt;data = data;</code></div>
    <div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">node-&gt;left = NULL;</code></div>
    <div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">node-&gt;right = NULL;</code></div>
    <div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code><code class="plain">(node);</code></div>
    <div class="line number26 index25 alt1"><code class="plain">&#125;</code></div>
    <div class="line number27 index26 alt2">&nbsp;</div>
    <div class="line number28 index27 alt1">&nbsp;</div>
    <div class="line number29 index28 alt2"><code
            class="comments">/* Change a tree so that the roles of the left and</code></div>
    <div class="line number30 index29 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">right pointers are swapped at every node.</code></div>
    <div class="line number31 index30 alt2">&nbsp;</div>
    <div class="line number32 index31 alt1"><code class="comments">So the tree...</code></div>
    <div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">4</code></div>
    <div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/ \</code></div>
    <div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">2 5</code></div>
    <div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/ \</code></div>
    <div class="line number37 index36 alt2"><code class="comments">1 3</code></div>
    <div class="line number38 index37 alt1">&nbsp;</div>
    <div class="line number39 index38 alt2"><code class="comments">is changed to...</code></div>
    <div class="line number40 index39 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">4</code></div>
    <div class="line number41 index40 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/ \</code></div>
    <div class="line number42 index41 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">5 2</code></div>
    <div class="line number43 index42 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/ \</code></div>
    <div class="line number44 index43 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">3 1</code></div>
    <div class="line number45 index44 alt2"><code class="comments">*/</code></div>
    <div class="line number46 index45 alt1"><code class="keyword bold">void</code> <code
            class="plain">mirror(</code><code class="keyword bold">struct</code> <code class="plain">Node* node)</code>
    </div>
    <div class="line number47 index46 alt2"><code class="plain">&#123;</code></div>
    <div class="line number48 index47 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(node == NULL)</code></div>
    <div class="line number49 index48 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code><code class="plain">;</code></div>
    <div class="line number50 index49 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">else</code></div>
    <div class="line number51 index50 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number52 index51 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">struct</code> <code class="plain">Node* temp;</code></div>
    <div class="line number53 index52 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number54 index53 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* do the subtrees */</code></div>
    <div class="line number55 index54 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">mirror(node-&gt;left);</code></div>
    <div class="line number56 index55 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">mirror(node-&gt;right);</code></div>
    <div class="line number57 index56 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number58 index57 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* swap the pointers in this node */</code></div>
    <div class="line number59 index58 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">temp&nbsp;&nbsp;&nbsp;&nbsp; = node-&gt;left;</code></div>
    <div class="line number60 index59 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">node-&gt;left = node-&gt;right;</code></div>
    <div class="line number61 index60 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">node-&gt;right = temp;</code></div>
    <div class="line number62 index61 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number63 index62 alt2"><code class="plain">&#125;</code></div>
    <div class="line number64 index63 alt1">&nbsp;</div>
    <div class="line number65 index64 alt2"><code class="comments">/* Helper function to print</code></div>
    <div class="line number66 index65 alt1"><code class="comments">Inorder traversal.*/</code></div>
    <div class="line number67 index66 alt2"><code class="keyword bold">void</code> <code
            class="plain">inOrder(</code><code class="keyword bold">struct</code> <code class="plain">Node* node)</code>
    </div>
    <div class="line number68 index67 alt1"><code class="plain">&#123;</code></div>
    <div class="line number69 index68 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(node == NULL)</code></div>
    <div class="line number70 index69 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code><code class="plain">;</code></div>
    <div class="line number71 index70 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number72 index71 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">inOrder(node-&gt;left);</code></div>
    <div class="line number73 index72 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; node-&gt;data &lt;&lt; </code><code class="string">" "</code><code
            class="plain">;</code></div>
    <div class="line number74 index73 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">inOrder(node-&gt;right);</code></div>
    <div class="line number75 index74 alt2"><code class="plain">&#125;</code></div>
    <div class="line number76 index75 alt1">&nbsp;</div>
    <div class="line number77 index76 alt2">&nbsp;</div>
    <div class="line number78 index77 alt1"><code class="comments">// Driver Code</code></div>
    <div class="line number79 index78 alt2"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
    <div class="line number80 index79 alt1"><code class="plain">&#123;</code></div>
    <div class="line number81 index80 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">struct</code> <code class="plain">Node *root = newNode(1);</code></div>
    <div class="line number82 index81 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">root-&gt;left = newNode(2);</code></div>
    <div class="line number83 index82 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">root-&gt;right = newNode(3);</code></div>
    <div class="line number84 index83 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">root-&gt;left-&gt;left = newNode(4);</code></div>
    <div class="line number85 index84 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">root-&gt;left-&gt;right = newNode(5);</code></div>
    <div class="line number86 index85 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number87 index86 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* Print inorder traversal of the input tree */</code></div>
    <div class="line number88 index87 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; </code><code class="string">"Inorder traversal of the constructed"</code></div>
    <div class="line number89 index88 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&lt;&lt; </code><code class="string">" tree is"</code> <code
            class="plain">&lt;&lt; endl;</code></div>
    <div class="line number90 index89 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">inOrder(root);</code></div>
    <div class="line number91 index90 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number92 index91 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* Convert tree to its mirror */</code></div>
    <div class="line number93 index92 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">mirror(root);</code></div>
    <div class="line number94 index93 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number95 index94 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* Print inorder traversal of the mirror tree */</code></div>
    <div class="line number96 index95 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; </code><code class="string">"\nInorder traversal of the mirror tree"</code>
    </div>
    <div class="line number97 index96 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&lt;&lt; </code><code class="string">" is \n"</code><code class="plain">;</code></div>
    <div class="line number98 index97 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">inOrder(root);</code></div>
    <div class="line number99 index98 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number100 index99 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">0;</code></div>
    <div class="line number101 index100 alt2"><code class="plain">&#125;</code></div>
    <div class="line number102 index101 alt1">&nbsp;</div>
    <div class="line number103 index102 alt2"><code class="comments">// This code is contributed by Akanksha Rai</code>
    </div>
</div>
      </div>
      <div id="tab-content-2" class="tab-content">
      <div class="container">
    <div class="line number1 index0 alt2"><code
            class="comments">// Java program to convert binary tree into its mirror</code></div>
    <div class="line number2 index1 alt1">&nbsp;</div>
    <div class="line number3 index2 alt2"><code
            class="comments">/* Class containing left and right child of current</code></div>
    <div class="line number4 index3 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="comments">node and key value*/</code></div>
    <div class="line number5 index4 alt2"><code class="keyword">class</code> <code class="plain">Node</code></div>
    <div class="line number6 index5 alt1"><code class="plain">&#123;</code></div>
    <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">data;</code></div>
    <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Node left, right;</code></div>
    <div class="line number9 index8 alt2">&nbsp;</div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">public</code> <code class="plain">Node(</code><code class="keyword">int</code> <code
            class="plain">item)</code></div>
    <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number12 index11 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">data = item;</code></div>
    <div class="line number13 index12 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">left = right = </code><code class="keyword">null</code><code class="plain">;</code></div>
    <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number15 index14 alt2"><code class="plain">&#125;</code></div>
    <div class="line number16 index15 alt1">&nbsp;</div>
    <div class="line number17 index16 alt2"><code class="keyword">class</code> <code class="plain">BinaryTree</code>
    </div>
    <div class="line number18 index17 alt1"><code class="plain">&#123;</code></div>
    <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Node root;</code></div>
    <div class="line number20 index19 alt1">&nbsp;</div>
    <div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">void</code> <code class="plain">mirror()</code></div>
    <div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number23 index22 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">root = mirror(root);</code></div>
    <div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number25 index24 alt2">&nbsp;</div>
    <div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Node mirror(Node node)</code></div>
    <div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number28 index27 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(node == </code><code class="keyword">null</code><code
            class="plain">)</code></div>
    <div class="line number29 index28 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="plain">node;</code></div>
    <div class="line number30 index29 alt1">&nbsp;</div>
    <div class="line number31 index30 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* do the subtrees */</code></div>
    <div class="line number32 index31 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Node left = mirror(node.left);</code></div>
    <div class="line number33 index32 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Node right = mirror(node.right);</code></div>
    <div class="line number34 index33 alt1">&nbsp;</div>
    <div class="line number35 index34 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* swap the left and right pointers */</code></div>
    <div class="line number36 index35 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">node.left = right;</code></div>
    <div class="line number37 index36 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">node.right = left;</code></div>
    <div class="line number38 index37 alt1">&nbsp;</div>
    <div class="line number39 index38 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code> <code class="plain">node;</code></div>
    <div class="line number40 index39 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number41 index40 alt2">&nbsp;</div>
    <div class="line number42 index41 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">void</code> <code class="plain">inOrder()</code></div>
    <div class="line number43 index42 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number44 index43 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">inOrder(root);</code></div>
    <div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number46 index45 alt1">&nbsp;</div>
    <div class="line number47 index46 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* Helper function to test mirror(). Given a binary</code></div>
    <div class="line number48 index47 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">search tree, print out its data elements in</code></div>
    <div class="line number49 index48 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">increasing sorted order.*/</code></div>
    <div class="line number50 index49 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">void</code> <code class="plain">inOrder(Node node)</code></div>
    <div class="line number51 index50 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number52 index51 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(node == </code><code class="keyword">null</code><code
            class="plain">)</code></div>
    <div class="line number53 index52 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code><code class="plain">;</code></div>
    <div class="line number54 index53 alt1">&nbsp;</div>
    <div class="line number55 index54 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">inOrder(node.left);</code></div>
    <div class="line number56 index55 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.print(node.data + </code><code class="string">" "</code><code
            class="plain">);</code></div>
    <div class="line number57 index56 alt2">&nbsp;</div>
    <div class="line number58 index57 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">inOrder(node.right);</code></div>
    <div class="line number59 index58 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number60 index59 alt1">&nbsp;</div>
    <div class="line number61 index60 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* testing for example nodes */</code></div>
    <div class="line number62 index61 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">public</code> <code class="keyword">static</code> <code class="keyword">void</code> <code
            class="plain">main(String args[])</code></div>
    <div class="line number63 index62 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number64 index63 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* creating a binary tree and entering the nodes */</code></div>
    <div class="line number65 index64 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">BinaryTree tree = </code><code class="keyword">new</code> <code
            class="plain">BinaryTree();</code></div>
    <div class="line number66 index65 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">tree.root = </code><code class="keyword">new</code> <code class="plain">Node(</code><code
            class="value">1</code><code class="plain">);</code></div>
    <div class="line number67 index66 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">tree.root.left = </code><code class="keyword">new</code> <code class="plain">Node(</code><code
            class="value">2</code><code class="plain">);</code></div>
    <div class="line number68 index67 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">tree.root.right = </code><code class="keyword">new</code> <code
            class="plain">Node(</code><code class="value">3</code><code class="plain">);</code></div>
    <div class="line number69 index68 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">tree.root.left.left = </code><code class="keyword">new</code> <code
            class="plain">Node(</code><code class="value">4</code><code class="plain">);</code></div>
    <div class="line number70 index69 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">tree.root.left.right = </code><code class="keyword">new</code> <code
            class="plain">Node(</code><code class="value">5</code><code class="plain">);</code></div>
    <div class="line number71 index70 alt2">&nbsp;</div>
    <div class="line number72 index71 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* print inorder traversal of the input tree */</code></div>
    <div class="line number73 index72 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(</code><code
            class="string">"Inorder traversal of input tree is :"</code><code class="plain">);</code></div>
    <div class="line number74 index73 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">tree.inOrder();</code></div>
    <div class="line number75 index74 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(</code><code class="string">""</code><code class="plain">);</code></div>
    <div class="line number76 index75 alt1">&nbsp;</div>
    <div class="line number77 index76 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* convert tree to its mirror */</code></div>
    <div class="line number78 index77 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">tree.mirror();</code></div>
    <div class="line number79 index78 alt2">&nbsp;</div>
    <div class="line number80 index79 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* print inorder traversal of the minor tree */</code></div>
    <div class="line number81 index80 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(</code><code
            class="string">"Inorder traversal of binary tree is : "</code><code class="plain">);</code></div>
    <div class="line number82 index81 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">tree.inOrder();</code></div>
    <div class="line number83 index82 alt2">&nbsp;</div>
    <div class="line number84 index83 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number85 index84 alt2"><code class="plain">&#125;</code></div>
</div>
        </div>
      <div id="tab-content-3" class="tab-content">
      <div class="container">
    <div class="line number1 index0 alt2"><code class="comments"># Python3 program to convert a binary</code></div>
    <div class="line number2 index1 alt1"><code class="comments"># tree to its mirror</code></div>
    <div class="line number3 index2 alt2">&nbsp;</div>
    <div class="line number4 index3 alt1"><code class="comments"># Utility function to create a new</code></div>
    <div class="line number5 index4 alt2"><code class="comments"># tree node</code></div>
    <div class="line number6 index5 alt1"><code class="keyword">class</code> <code class="plain">newNode:</code></div>
    <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">def</code> <code class="plain">__init__(</code><code class="color1">self</code><code
            class="plain">,data):</code></div>
    <div class="line number8 index7 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1">self</code><code class="plain">.data </code><code class="keyword">=</code> <code
            class="plain">data</code></div>
    <div class="line number9 index8 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1">self</code><code class="plain">.left </code><code class="keyword">=</code> <code
            class="color1">self</code><code class="plain">.right </code><code class="keyword">=</code> <code
            class="color1">None</code></div>
    <div class="line number10 index9 alt1">&nbsp;</div>
    <div class="line number11 index10 alt2"><code class="comments">""" Change a tree so that the roles of the</code>
    </div>
    <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">left and right pointers are swapped at</code></div>
    <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">every node.</code></div>
    <div class="line number14 index13 alt1">&nbsp;</div>
    <div class="line number15 index14 alt2"><code class="comments">So the tree...</code></div>
    <div class="line number16 index15 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">4</code></div>
    <div class="line number17 index16 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/ \</code></div>
    <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">2 5</code></div>
    <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/ \</code></div>
    <div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">1 3</code></div>
    <div class="line number21 index20 alt2">&nbsp;</div>
    <div class="line number22 index21 alt1"><code class="comments">is changed to...</code></div>
    <div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">4</code></div>
    <div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/ \</code></div>
    <div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">5 2</code></div>
    <div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/ \</code></div>
    <div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">3 1</code></div>
    <div class="line number28 index27 alt1"><code class="comments">"""</code></div>
    <div class="line number29 index28 alt2"><code class="keyword">def</code> <code class="plain">mirror(node):</code>
    </div>
    <div class="line number30 index29 alt1">&nbsp;</div>
    <div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(node </code><code class="keyword">=</code><code
            class="keyword">=</code> <code class="color1">None</code><code class="plain">):</code></div>
    <div class="line number32 index31 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code></div>
    <div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">else</code><code class="plain">:</code></div>
    <div class="line number34 index33 alt1">&nbsp;</div>
    <div class="line number35 index34 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">temp </code><code class="keyword">=</code> <code class="plain">node</code></div>
    <div class="line number36 index35 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number37 index36 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">""" do the subtrees """</code></div>
    <div class="line number38 index37 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">mirror(node.left)</code></div>
    <div class="line number39 index38 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">mirror(node.right)</code></div>
    <div class="line number40 index39 alt1">&nbsp;</div>
    <div class="line number41 index40 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">""" swap the pointers in this node """</code></div>
    <div class="line number42 index41 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">temp </code><code class="keyword">=</code> <code class="plain">node.left</code></div>
    <div class="line number43 index42 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">node.left </code><code class="keyword">=</code> <code class="plain">node.right</code></div>
    <div class="line number44 index43 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">node.right </code><code class="keyword">=</code> <code class="plain">temp</code></div>
    <div class="line number45 index44 alt2">&nbsp;</div>
    <div class="line number46 index45 alt1"><code
            class="comments">""" Helper function to print Inorder traversal."""</code></div>
    <div class="line number47 index46 alt2"><code class="keyword">def</code> <code class="plain">inOrder(node) :</code>
    </div>
    <div class="line number48 index47 alt1">&nbsp;</div>
    <div class="line number49 index48 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(node </code><code class="keyword">=</code><code
            class="keyword">=</code> <code class="color1">None</code><code class="plain">):</code></div>
    <div class="line number50 index49 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">return</code></div>
    <div class="line number51 index50 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number52 index51 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">inOrder(node.left)</code></div>
    <div class="line number53 index52 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">print</code><code class="plain">(node.data, end </code><code class="keyword">=</code> <code
            class="string">" "</code><code class="plain">)</code></div>
    <div class="line number54 index53 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">inOrder(node.right)</code></div>
    <div class="line number55 index54 alt2">&nbsp;</div>
    <div class="line number56 index55 alt1"><code class="comments"># Driver code</code></div>
    <div class="line number57 index56 alt2"><code class="keyword">if</code> <code class="plain">__name__ </code><code
            class="keyword">=</code><code class="keyword">=</code><code class="string">"__main__"</code><code
            class="plain">:</code></div>
    <div class="line number58 index57 alt1">&nbsp;</div>
    <div class="line number59 index58 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">root </code><code class="keyword">=</code> <code class="plain">newNode(</code><code
            class="value">1</code><code class="plain">)</code></div>
    <div class="line number60 index59 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">root.left </code><code class="keyword">=</code> <code class="plain">newNode(</code><code
            class="value">2</code><code class="plain">)</code></div>
    <div class="line number61 index60 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">root.right </code><code class="keyword">=</code> <code class="plain">newNode(</code><code
            class="value">3</code><code class="plain">)</code></div>
    <div class="line number62 index61 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">root.left.left </code><code class="keyword">=</code> <code class="plain">newNode(</code><code
            class="value">4</code><code class="plain">)</code></div>
    <div class="line number63 index62 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">root.left.right </code><code class="keyword">=</code> <code class="plain">newNode(</code><code
            class="value">5</code><code class="plain">)</code></div>
    <div class="line number64 index63 alt1">&nbsp;</div>
    <div class="line number65 index64 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">""" Print inorder traversal of</code></div>
    <div class="line number66 index65 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">the input tree """</code></div>
    <div class="line number67 index66 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">print</code><code class="plain">(</code><code
            class="string">"Inorder traversal of the"</code><code class="plain">,</code></div>
    <div class="line number68 index67 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="string">"constructed tree is"</code><code class="plain">)</code></div>
    <div class="line number69 index68 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">inOrder(root)</code></div>
    <div class="line number70 index69 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number71 index70 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">""" Convert tree to its mirror """</code></div>
    <div class="line number72 index71 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">mirror(root)</code></div>
    <div class="line number73 index72 alt2">&nbsp;</div>
    <div class="line number74 index73 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">""" Print inorder traversal of</code></div>
    <div class="line number75 index74 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">the mirror tree """</code></div>
    <div class="line number76 index75 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions">print</code><code class="plain">(</code><code
            class="string">"\nInorder traversal of"</code><code class="plain">,</code></div>
    <div class="line number77 index76 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="string">"the mirror treeis "</code><code class="plain">)</code></div>
    <div class="line number78 index77 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">inOrder(root)</code></div>
    <div class="line number79 index78 alt2">&nbsp;</div>
    <div class="line number80 index79 alt1"><code class="comments"># This code is contributed by</code></div>
    <div class="line number81 index80 alt2"><code class="comments"># Shubham Singh(SHUBHAMSINGH10)</code></div>
</div>
        </div>
     
       
      <div id="tab-content-4" class="tab-content">
      <div class="container">
    <div class="line number1 index0 alt2"><code class="comments">// C program to convert a binary tree</code></div>
    <div class="line number2 index1 alt1"><code class="comments">// to its mirror</code></div>
    <div class="line number3 index2 alt2"><code class="preprocessor">#include&lt;stdio.h&gt;</code></div>
    <div class="line number4 index3 alt1"><code class="preprocessor">#include&lt;stdlib.h&gt;</code></div>
    <div class="line number5 index4 alt2">&nbsp;</div>
    <div class="line number6 index5 alt1"><code class="comments">/* A binary tree node has data, pointer</code></div>
    <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="comments">to left child and a pointer to right child */</code></div>
    <div class="line number8 index7 alt1"><code class="keyword bold">struct</code> <code class="plain">Node</code></div>
    <div class="line number9 index8 alt2"><code class="plain">&#123;</code></div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">data;</code></div>
    <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">struct</code> <code class="plain">Node* left;</code></div>
    <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">struct</code> <code class="plain">Node* right;</code></div>
    <div class="line number13 index12 alt2"><code class="plain">&#125;;</code></div>
    <div class="line number14 index13 alt1">&nbsp;</div>
    <div class="line number15 index14 alt2"><code
            class="comments">/* Helper function that allocates a new node with the</code></div>
    <div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="comments">given data and NULL left and right pointers. */</code></div>
    <div class="line number17 index16 alt2"><code class="keyword bold">struct</code> <code
            class="plain">Node* newNode(</code><code class="color1 bold">int</code> <code class="plain">data)</code>
    </div>
    <div class="line number18 index17 alt1">&nbsp;</div>
    <div class="line number19 index18 alt2"><code class="plain">&#123;</code></div>
    <div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="keyword bold">struct</code> <code class="plain">Node* node = (</code><code
            class="keyword bold">struct</code> <code class="plain">Node*)</code></div>
    <div class="line number21 index20 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions bold">malloc</code><code class="plain">(</code><code
            class="keyword bold">sizeof</code><code class="plain">(</code><code class="keyword bold">struct</code> <code
            class="plain">Node));</code></div>
    <div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="plain">node-&gt;data = data;</code></div>
    <div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="plain">node-&gt;left = NULL;</code></div>
    <div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="plain">node-&gt;right = NULL;</code></div>
    <div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="keyword bold">return</code><code class="plain">(node);</code></div>
    <div class="line number27 index26 alt2"><code class="plain">&#125;</code></div>
    <div class="line number28 index27 alt1">&nbsp;</div>
    <div class="line number29 index28 alt2">&nbsp;</div>
    <div class="line number30 index29 alt1"><code
            class="comments">/* Change a tree so that the roles of the&nbsp; left and</code></div>
    <div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">right pointers are swapped at every node.</code></div>
    <div class="line number32 index31 alt1">&nbsp;</div>
    <div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;</code><code
            class="comments">So the tree...</code></div>
    <div class="line number34 index33 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="comments">4</code>
    </div>
    <div class="line number35 index34 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="comments">/ \</code></div>
    <div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">2&nbsp;&nbsp; 5</code></div>
    <div class="line number37 index36 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/ \</code></div>
    <div class="line number38 index37 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="comments">1&nbsp;&nbsp; 3</code></div>
    <div class="line number39 index38 alt2">&nbsp;</div>
    <div class="line number40 index39 alt1"><code class="undefined spaces">&nbsp;</code><code
            class="comments">is changed to...</code></div>
    <div class="line number41 index40 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="comments">4</code>
    </div>
    <div class="line number42 index41 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="comments">/ \</code></div>
    <div class="line number43 index42 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">5&nbsp;&nbsp; 2</code></div>
    <div class="line number44 index43 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/ \</code></div>
    <div class="line number45 index44 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">3&nbsp;&nbsp; 1</code></div>
    <div class="line number46 index45 alt1"><code class="comments">*/</code></div>
    <div class="line number47 index46 alt2"><code class="keyword bold">void</code> <code
            class="plain">mirror(</code><code class="keyword bold">struct</code> <code class="plain">Node* node)</code>
    </div>
    <div class="line number48 index47 alt1"><code class="plain">&#123;</code></div>
    <div class="line number49 index48 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(node==NULL)</code></div>
    <div class="line number50 index49 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code><code class="plain">;&nbsp;</code></div>
    <div class="line number51 index50 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="keyword bold">else</code></div>
    <div class="line number52 index51 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number53 index52 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">struct</code> <code class="plain">Node* temp;</code></div>
    <div class="line number54 index53 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number55 index54 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* do the subtrees */</code></div>
    <div class="line number56 index55 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">mirror(node-&gt;left);</code></div>
    <div class="line number57 index56 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">mirror(node-&gt;right);</code></div>
    <div class="line number58 index57 alt1">&nbsp;</div>
    <div class="line number59 index58 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* swap the pointers in this node */</code></div>
    <div class="line number60 index59 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">temp&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; = node-&gt;left;</code></div>
    <div class="line number61 index60 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">node-&gt;left&nbsp; = node-&gt;right;</code></div>
    <div class="line number62 index61 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">node-&gt;right = temp;</code></div>
    <div class="line number63 index62 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number64 index63 alt1"><code class="plain">&#125;</code></div>
    <div class="line number65 index64 alt2">&nbsp;</div>
    <div class="line number66 index65 alt1"><code
            class="comments">/* Helper function to print Inorder traversal.*/</code></div>
    <div class="line number67 index66 alt2"><code class="keyword bold">void</code> <code
            class="plain">inOrder(</code><code class="keyword bold">struct</code> <code class="plain">Node* node)</code>
    </div>
    <div class="line number68 index67 alt1"><code class="plain">&#123;</code></div>
    <div class="line number69 index68 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(node == NULL)</code></div>
    <div class="line number70 index69 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code><code class="plain">;</code></div>
    <div class="line number71 index70 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number72 index71 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="plain">inOrder(node-&gt;left);</code></div>
    <div class="line number73 index72 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="functions bold">printf</code><code class="plain">(</code><code class="string">"%d "</code><code
            class="plain">, node-&gt;data);</code></div>
    <div class="line number74 index73 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="plain">inOrder(node-&gt;right);</code></div>
    <div class="line number75 index74 alt2"><code class="plain">&#125;&nbsp;</code></div>
    <div class="line number76 index75 alt1">&nbsp;</div>
    <div class="line number77 index76 alt2">&nbsp;</div>
    <div class="line number78 index77 alt1"><code class="comments">/* Driver program to test mirror() */</code></div>
    <div class="line number79 index78 alt2"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
    <div class="line number80 index79 alt1"><code class="plain">&#123;</code></div>
    <div class="line number81 index80 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="keyword bold">struct</code> <code class="plain">Node *root = newNode(1);</code></div>
    <div class="line number82 index81 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="plain">root-&gt;left&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; = newNode(2);</code></div>
    <div class="line number83 index82 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="plain">root-&gt;right&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; = newNode(3);</code></div>
    <div class="line number84 index83 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="plain">root-&gt;left-&gt;left&nbsp; = newNode(4);</code></div>
    <div class="line number85 index84 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="plain">root-&gt;left-&gt;right = newNode(5);</code></div>
    <div class="line number86 index85 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number87 index86 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="comments">/* Print inorder traversal of the input tree */</code></div>
    <div class="line number88 index87 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="functions bold">printf</code><code class="plain">(</code><code
            class="string">"Inorder traversal of the constructed"</code></div>
    <div class="line number89 index88 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="string">" tree is \n"</code><code class="plain">);</code></div>
    <div class="line number90 index89 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="plain">inOrder(root);</code></div>
    <div class="line number91 index90 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number92 index91 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="comments">/* Convert tree to its mirror */</code></div>
    <div class="line number93 index92 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="plain">mirror(root);</code></div>
    <div class="line number94 index93 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number95 index94 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="comments">/* Print inorder traversal of the mirror tree */</code></div>
    <div class="line number96 index95 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="functions bold">printf</code><code class="plain">(</code><code
            class="string">"\nInorder traversal of the mirror tree"</code></div>
    <div class="line number97 index96 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="string">" is \n"</code><code class="plain">);&nbsp;</code></div>
    <div class="line number98 index97 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="plain">inOrder(root);</code></div>
    <div class="line number99 index98 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number100 index99 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">0;&nbsp;</code></div>
    <div class="line number101 index100 alt2"><code class="plain">&#125;</code></div>
</div>
        </div>
        </div>
  </div>
        </div>
    )
}

export default Ola6
